import { useMutation, useQuery, useQueryClient } from "react-query";
import { generatePath } from "react-router-dom";
import { useApiRequest } from "system/api/hooks";
import {
  API_UPDATE_COUNTRIES,
  API_CREATE_COUNTRIES,
  API_GET_COUNTRIES,
  API_GET_COUNTRY,
  API_DELETE_COUNTRIES,
} from "system/api/apiUrls";
import { generateUrlQuery } from "system/helpers/helperFunctions";
import { useApiErrors } from "system/helpers/apiErrorHelper";
import { useSuccessToast } from "system/helpers/hooks";
import { ErrorType } from "system/helpers/types";
import { CountriesDataType, CurrencyDataType } from "modules/countries/types";

const getCountriesKey = "getCountriesKey";
const getCurrencyKey = "getCurrencyKey";
export const useGetCountries = (filters: any = {}) => {
  const [apiRequest] = useApiRequest();
  return useQuery(
    [getCountriesKey, filters],
    (): Promise<CountriesDataType> =>
      apiRequest({
        url: generateUrlQuery(API_GET_COUNTRIES, filters),
        method: "get",
      })
  );
};
export const useGetCountry = (id: string) => {
  const [apiRequest] = useApiRequest();
  return useQuery(
    [getCurrencyKey, id],
    (): Promise<CurrencyDataType> =>
      apiRequest({
        url: generatePath(API_GET_COUNTRY, { id }),
        method: "get",
      })
  );
};

export const useCreateCountries = () => {
  const [apiRequest] = useApiRequest();
  const queryClient = useQueryClient();
  const { apiErrors } = useApiErrors();
  const { apiSuccessMessage } = useSuccessToast();
  return useMutation(
    (data: any) =>
      apiRequest({
        url: generatePath(API_CREATE_COUNTRIES, {
          id: data.id,
        }),
        method: "put",
        data: data.data,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(getCountriesKey);
        apiSuccessMessage();
      },
      onError: (err: ErrorType) => apiErrors(err),
    }
  );
};
export const useDeleteCountries = () => {
  const [apiRequest] = useApiRequest();
  const queryClient = useQueryClient();
  const { apiErrors } = useApiErrors();
  const { apiSuccessMessage } = useSuccessToast();
  return useMutation(
    (data: any) =>
      apiRequest({
        url: generatePath(API_DELETE_COUNTRIES, {
          id: data.id,
        }),
        method: "delete",
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(getCountriesKey);
        apiSuccessMessage();
      },
      onError: (err: ErrorType) => apiErrors(err),
    }
  );
};
export const useUpdateCountries = () => {
  const [apiRequest] = useApiRequest();
  const queryClient = useQueryClient();
  const { apiErrors } = useApiErrors();
  const { apiSuccessMessage } = useSuccessToast();
  return useMutation(
    (data: any) =>
      apiRequest({
        url: generatePath(API_UPDATE_COUNTRIES, {
          id: data.id,
        }),
        method: "post",
        data: data.data,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(getCountriesKey);
        apiSuccessMessage();
      },
      onError: (err: ErrorType) => apiErrors(err),
    }
  );
};
